import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 32,
		height: 32,
		transform: 'rotate(45deg)',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 32,
			// height: 32,
		},
	},
}));

function BackToOld(props) {
	return (
		<svg width="24" height="32" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M15.0986 7.00541C15.6417 7.00541 16.082 7.44572 16.082 7.98887C16.082 8.53202 15.6417 8.97233 15.0986 8.97233H3.89453L8.77329 13.8875C9.15991 14.277 9.15859 14.9059 8.77035 15.2937C8.38146 15.6823 7.75135 15.6823 7.36247 15.2937L0.0507812 7.98887L7.36247 0.683997C7.75135 0.295478 8.38146 0.295478 8.77035 0.683997C9.15859 1.07188 9.15991 1.70074 8.77329 2.09024L3.89453 7.00541H15.0986Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<BackToOld fill={props.fill} />
		</div>
	);
}